import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

export function MeetEducatorsSection() {
    const navigate = useNavigate();

    return (
        <section className="w-full bg-brand-surface py-20 px-6 md:px-12 lg:px-24 overflow-hidden border-y border-brand-border">
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

                {/* Left Side: Image Collage */}
                <div className="relative h-[500px] w-full hidden md:block">
                    {/* Decorative Elements */}
                    <div className="absolute top-10 left-10 w-20 h-20 bg-brand-primary rounded-full opacity-20 blur-xl" />
                    <div className="absolute bottom-10 right-10 w-32 h-32 bg-brand-dark rounded-full opacity-10 blur-xl" />

                    {/* Images */}
                    <motion.div
                        className="absolute top-0 left-0 w-48 h-64 rounded-2xl overflow-hidden shadow-lg transform -rotate-6 z-10"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                    >
                        <img src="/profile_teacher_black.png" alt="Teacher" className="w-full h-full object-cover" />
                        <div className="absolute bottom-4 left-4 bg-white/90 px-3 py-1 rounded-full text-xs font-bold text-brand-dark shadow-sm">
                            Keisha, 29
                        </div>
                    </motion.div>

                    <motion.div
                        className="absolute top-12 right-8 w-40 h-56 rounded-2xl overflow-hidden shadow-lg transform rotate-3 z-20"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                        viewport={{ once: true }}
                    >
                        <img src="/profile_male_black.png" alt="Educator" className="w-full h-full object-cover" />
                        <div className="absolute bottom-4 right-4 bg-brand-primary/90 px-3 py-1 rounded-full text-xs font-bold text-brand-dark shadow-sm">
                            Marcus, 34
                        </div>
                    </motion.div>

                    <motion.div
                        className="absolute bottom-8 left-12 w-44 h-56 rounded-2xl overflow-hidden shadow-lg transform rotate-2 z-30"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        viewport={{ once: true }}
                    >
                        <img src="/profile_teacher_2.png" alt="Teacher" className="w-full h-full object-cover" />
                    </motion.div>

                    <motion.div
                        className="absolute bottom-0 right-20 w-36 h-48 rounded-2xl overflow-hidden shadow-lg transform -rotate-3 z-10"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.3 }}
                        viewport={{ once: true }}
                    >
                        <img src="/profile_male_2.png" alt="Educator" className="w-full h-full object-cover" />
                    </motion.div>
                </div>

                {/* Right Side: Content */}
                <div className="space-y-6">
                    <div className="inline-block p-3 bg-brand-primary rounded-full mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-brand-dark"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                    </div>

                    <h2 className="text-4xl md:text-5xl font-bold text-brand-text leading-tight">
                        Meet other Educators
                    </h2>

                    <p className="text-lg text-brand-muted leading-relaxed">
                        Connect with a community that understands your world. Whether you're looking for a partner who gets the grading grind or someone to share your summer break with, Hall Pass brings educators together.
                    </p>

                    <div className="pt-4">
                        <Button
                            size="lg"
                            className="bg-brand-primary text-brand-background hover:bg-brand-primary/90 text-lg px-8 py-6 rounded-full shadow-lg font-semibold"
                            onClick={() => navigate("/role-selection")}
                        >
                            Join the Community
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
}
